<template>
  <div id="root">
    <div id="popupContainer" />
    <div id="contentContainer">
      <div id="title">로그인에 실패했습니다.</div>
      <div id="caption">이메일 또는 비밀번호를 확인해주세요.</div>
      <div id="confirmButton" @click="onConfirmButton">확인</div>
    </div>
  </div>

</template>

<script>
import {mapMutations} from "vuex";

export default {
  name: "PopupDialogComponent",
  data() {
    return {
    }
  },
  methods: {
    ...mapMutations(["setShowDlconLoginFailedPopup"]),
    onConfirmButton() {
      this.setShowDlconLoginFailedPopup(false);
    }
  }
}
</script>

<style scoped>
#root {
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  background: #FFFFFF;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}

#popupContainer
{
  z-index: -1;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  background: #000000;
  opacity: 0.6;
}

#contentContainer {
  width: 461px;
  height: 230px;
  background: #FFFFFF;
  border-radius: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
#title {
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.6px;
  color: #333333;
  margin-bottom: 16px;
}

#caption {
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  letter-spacing: -0.6px;
  color: #A5A5A5;
  margin-bottom: 28px;
}

#confirmButton {
  width: 151px;
  height: 50px;
  background: #333333;
  border-radius: 100px;

  text-align: center;
  letter-spacing: -0.6px;
  color: #FFFFFF;
  font-size: 18px;
  line-height: 18px;
  padding-top: 16px;
}

#confirmButton:hover {
  cursor: pointer;
}

</style>
